import config, { isDevelopment, isLocal, isUAT } from "./config";
import * as Sentry from "@sentry/react";

isDevelopment &&
  Sentry.init({
    dsn: config.SENTRY_URL,
    sendDefaultPii: true,
    environment: isDevelopment ? (isLocal ? "local" : isUAT ? "uat" : "development") : "production"
  });
